import type { ClaimsFeatureConfig } from '../../../types/features/ClaimsFeatureConfig';

export const claims: ClaimsFeatureConfig = {
    fetchClaimsWithoutFlag: false,
    showPageCaption: false,
    showClaimsSection: false,
};
